export interface CallDirectionReportParameter {
   value: ReportCallDirections;
}

export enum ReportCallDirections {
   'Inbound' = 'Inbound',
   'Outbound' = 'Outbound',
   'Both' = 'Both',
}
